import type { TextProps as AriaTextProps } from 'react-aria-components';
import { Text as AriaText } from 'react-aria-components';
import styles from './FieldDescription.module.css';

export interface FieldDescriptionProps extends AriaTextProps {
  className?: string;
}

const FieldDescription = ({ className, children, ...props }: AriaTextProps) => {
  return (
    <AriaText
      className={`${styles.fieldDescription} ${className || ''}`}
      slot="description"
      {...props}
    >
      {children}
    </AriaText>
  );
};

export default FieldDescription;
